<template>
  <div class="statistic-wrap">
    <div class="card statistic-table">
      <div class="card-header" v-if="title">
        {{ title }}
        <div class="card-actions">
          <slot name="table-actions"></slot>
          <button class="btn-close" @click="exporting"><i class="fa fa-download"></i></button>
          <button v-if="title === `${$t('pages.orders')}`" class="btn-close" title="pdf" @click="downloadAll"><i class="fa fa-file-pdf-o"></i></button>
          <button v-if="title === `${$t('pages.receipt')}`" class="btn-close" title="pdf" @click="downloadAllReceipt"><i class="fa fa-file-pdf-o"></i></button>
        </div>
      </div>
      <div class="table-loader" style="padding: 50px 0; text-align: center; width: 100%" v-if="isLoading">
        <i class="fa fa-spinner fa-spin fa-5x fa-fw"></i>
      </div>
      <div v-if="!isLoading" :class="idElem">
        <table class="table table-responsive" v-bind:id="idElem">
          <thead>
            <tr v-if="preheatColumns">
              <th v-for="col in preheatColumns" :colspan="col.colspan" :width="col.width ? col.width : 'auto'" class="th-action">{{ col.label }}</th>
            </tr>
            <tr>
              <th v-for="(col, index) in headColumns"
                  :colspan="col.colspan"
                  class="th-action"
                  @click="sort(col.field, index)"
                  :width="col.width ? col.width : 'auto'"
              >{{ col.label }}
              </th>
            </tr>
          </thead>

          <tbody>

            <tr v-for="row in rows" :key="row.key">
              <td
                  v-for="(cell, i) in row.value"
                  :key="cell.offer_id"  :width="cell.widthTd ? cell.widthTd : 'auto'" :style="renderBackground(cell)"
              >
                <template v-if="cell.key === 'country_id'">
                  {{ Helper.findCountryName(cell.value) }}
                </template>
                <template v-if="cell.key === 'offer_id' || cell.key === 'product_id'">
                  {{ getOfferName(cell.value) }}
                </template>
                <template v-else-if="cell.key == 'credit'">
                  <template v-if="cell.value == 0">
                    <template v-if="row.showInput == false">
                      <span @click="showClick(row)">Оплачено</span>
                    </template>
                    <template v-else>
                      <input class="cellInput" type="text" :value="cell.value" v-model="cell.value" @change="changeTableVal(row.key, cell)" :placeholder="cell.input.placeholder ? cell.input.placeholder : ''">
                    </template>
                  </template>
                  <template v-else>
                    <input class="cellInput" type="text" :value="cell.value" v-model="cell.value" @change="changeTableVal(row.key, cell)" :placeholder="cell.input.placeholder ? cell.input.placeholder : ''">
                  </template>
                </template>
                <template v-else-if="cell.key === 'is_ordered'">
                 <template v-if="cell.value === 1">
                   Заказан
                 </template>
                </template>
                <template v-else>
                  <template v-if="cell.input">
                      <template v-if="cell.input.type === 'number'">
                        <input class="cellInput" type="number" :value="cell.value" v-model="cell.value"  @change="changeTableVal(row.key, cell)" :placeholder="cell.input.placeholder ? cell.input.placeholder : ''">
                      </template>
                      <template v-if="cell.input.type === 'text'">
                        <input class="cellInput" type="text" :value="cell.value" v-model="cell.value" @change="changeTableVal(row.key, cell)" :placeholder="cell.input.placeholder ? cell.input.placeholder : ''">
                      </template>
                      <template v-if="cell.input.type === 'date'">
                        <DatePicker :wrapper-class="'date'" :input-class="'cellInput'" :language="Storage.language"  v-model="cell.value" @input="changeTableVal(row.key, cell)" :placeholder="cell.input.placeholder ? cell.input.placeholder : ''"
                          format="yyyy-MM-dd"></DatePicker>
                      </template>
                      <template v-if="cell.input.type === 'selectStatus'">
                        <select class="cellInput" name="status" v-model="cell.value" @change="changeTableVal(row.key, cell)">
                          <option value="0">Заказан</option>
                          <option value="1">Отгружен</option>
                        </select>
                      </template>
                  </template>
                  <template v-else-if="cell.key !== 'country_id'">
                    {{ cell.value }}
                  </template>
                </template>
                <template v-if="cell.aux">
                  {{ cell.aux }}
                </template>
              </td>
              <td :key="'action-' + row.key" v-if="!disableActionBTN">
                  <slot name="table-actions"></slot>
                  <button class="btn-close" title="Сохранить" @click="saveChange(row.key)"><i class="fa fa-check"></i></button>
                  <button class="btn-close" title="Удалить" @click="deleteChange(row.key)"><i class="fa fa-trash"></i></button>
                  <button class="btn-close" title="PDF" @click="download(row.key)"><i class="fa fa-download"></i></button>
                  <button class="btn-close btn-file" title="Image">
                      <input @change="uploadImage(row.key, $event.target.name, $event.target.files)"  class="form-control input files" ref="file"  type="file">
                      <i class="fa fa-picture-o"></i>
                  </button>

              </td>
              <td :key="'action-' + row.key" v-if="isActiveBtn">
                  <slot name="table-actions"></slot>
                  <button class="btn-close btn-close-receipt" title="PDF" @click="downloadPdfReceipt(row.key)"><i class="fa fa-download"></i></button>
                  <button class="btn-close btn-file btn-close-receipt" title="Image">
                      <input @change="uploadImageReceipt(row.key, $event.target.name, $event.target.files)"  class="form-control input files" ref="file"  type="file">
                      <i class="fa fa-picture-o"></i>
                  </button>
              </td>
            </tr>

          </tbody>
        </table>

      </div>

    </div>
  </div>
</template>

<script>

  import FileSaver from 'file-saver'
  import { find, size, filter, orderBy } from 'lodash'
  import Helper from '@/api/Helper'
  import DatePicker from 'vuejs-datepicker'
  import Storage from '../api/Storage'

  export default {
    name: 'OrderTable',
    components: {
      DatePicker
    },
    props: {
      title: {
        type: String,
        required: false
      },
      disableActionBTN: Boolean,
      isActiveBtn: Boolean,
      headColumns: {
        type: Array,
        required: true
      },
      rows: {
        type: Array,
        required: true
      },
      idElem: {
        type: String,
        required: false
      },
      footColumns: {
        type: Object,
        required: true
      },
      columns: {
        type: Object,
        required: false
      },
      preheatColumns: {
        type: Array,
        required: false
      },
      isLoading: {
        type: Boolean,
        required: false
      }
    },
    data () {
      return {
        id: null,
        Storage: Storage,
        order: 'asc',
        Helper: Helper
      }
    },
    mounted () {
      this.id = Math.random().toString(36).replace(/[^a-z]+/g, '').substr(0, 8)
      this.$root.$on('data_loading', () => {
        this.isLoading = true
      })
      this.$root.$on('data_loaded', () => {
        this.isLoading = false
      })
    },
    methods: {
      showClick (row) {
        row.showInput = true
      },
      getOfferName (id) {
        const offer = Helper.getGoodName(Storage.goods, id)
        return offer || 'Не найдено'
      },
      sort (field, index) {
        this.order = (this.order === 'asc' ? 'desc' : 'asc')
        this.rows = orderBy(this.rows, [(o) => { return o.value[index].value }], [this.order])
      },
      saveChange (offerId) {
        this.$emit('addReceipt', offerId)
      },
      deleteChange (offerId) {
        this.$emit('deleteChange', offerId)
      },
      downloadAll () {
        this.$emit('downloadAll', {rows: this.rows})
      },
      downloadAllReceipt () {
        this.$emit('downloadAllReceipt', {rows: this.rows})
      },
      download (offerId) {
        this.$emit('download', offerId)
      },
      downloadPdfReceipt (offerId) {
        this.$emit('downloadPdfReceipt', offerId)
      },
      uploadImage (offerId, files, name) {
        this.$emit('uploadImage', offerId, files, name)
      },
      uploadImageReceipt (offerId, files, name) {
        this.$emit('uploadImageReceipt', offerId, files, name)
      },
      changeTableVal (offerId, cell) {
        const rowsEdit = find(this.rows, {key: offerId})
        this.$emit('changeVal', rowsEdit.key, cell)
      },
      exporting (evt) {
        let doc = `<html xmlns:o="urn:schemas-microsoft-com:office:office" xmlns:x="urn:schemas-microsoft-com:office:excel" xmlns="http://www.w3.org/TR/REC-html40"><head><meta charset="UTF-8"><!--[if gte mso 9]><xml><x:ExcelWorkbook><x:ExcelWorksheets><x:ExcelWorksheet><x:Name>${this.title}</x:Name><x:WorksheetOptions><x:DisplayGridlines/></x:WorksheetOptions></x:ExcelWorksheet></x:ExcelWorksheets></x:ExcelWorkbook></xml><![endif]--></head><body>`
        doc += document.getElementById(this.id).innerHTML
        doc += '</body></html>'
        FileSaver.saveAs(new Blob([doc], {
          encoding: 'UTF-8',
          type: 'application/octet-stream'
        }), `analytics-${this.title}-${new Date().toLocaleString()}.xls`)
      },
      renderBackground (cell) {
        let style = !cell.style ? {} : cell.style
        if (cell.color) {
          const elseObj = filter(cell.color, (obj) => { return obj.value === 'else' })
          const bigObj = filter(cell.color, (obj) => { return obj.value === '>0' })
          const colorObj = filter(cell.color, (obj) => { return obj.value === Number(cell.value) })
          if (size(colorObj) > 0) {
            style.backgroundColor = colorObj[0].bg
          } else if (size(elseObj) > 0) {
            style.backgroundColor = elseObj[0].bg
          } else if (size(bigObj) > 0) {
            if (cell.value > 0) {
              style.backgroundColor = bigObj[0].bg
            }
          }
          // style.backgroundColor = !cell.value ? '#f5c468' : '#53d3a2'
          // console.log(cell.color)
        }
        if (cell.bg) {
          const procent = (cell.value / cell.bg.maxday) * 100
          style.background = `linear-gradient(to right, ${cell.bg.colorBg} ${procent}%, transparent 0%)`
        }
        return style
      }
    }
  }
</script>

<style>
  .block {
    width: 100%;
    height: 100%;
  }
  .date{
    text-align: center !important;
  }
  .yellow {
    background-color: rgb(255, 249, 196);
  }
  .green {
    background-color: rgb(129, 199, 132);
  }
  .cellInput {
    border: none;
    background: transparent;
    text-align: center;
  }
  .cellInput:focus{
    text-align: left;
  }
  #remnants{
    table-layout: fixed;
    border-collapse: collapse;
  }
  #remnants thead tr{
    display:table;
  }
  #remnants thead th{
    vertical-align: middle;
  }
  #remnants tbody{
    height: 500px;
    display: table;
    width: 100%;
  }
  .remnants {
    height: 500px;
    overflow-y: auto;
  }
  .btn-close {
    width: 30px;
    height: 30px;
  }
  .btn-file {
      position: relative;
      overflow: hidden;
  }
  .btn-file input[type=file] {
      position: absolute;
      top: 0;
      right: 0;
      min-width: 100%;
      min-height: 100%;
      font-size: 100px;
      text-align: right;
      filter: alpha(opacity=0);
      opacity: 0;
      outline: none;
      background: white;
      cursor: inherit;
      display: block;
  }
  .btn-close-receipt {
      margin-bottom: 5px;
  }
  .btn-close-receipt:last-child {
      margin-bottom: 0;
  }
</style>



// WEBPACK FOOTER //
// OrderTable.vue?4eec9e06